export const portfolioSettings = {
  hero_eyebrow: 'Independent Designer',
  hero_heading: 'Digital work with a human edge.',
  hero_description: 'Focused identities and interfaces for ambitious teams.',
  hero_cta_text: 'View projects',
  hero_cta_url: '#projects',
  hero_image: {
    url: 'https://images.unsplash.com/photo-1558655146-9f40138edfeb?auto=format&fit=crop&w=1600&q=85',
    alt: 'Creative workspace with design materials'
  },
  contact_heading: 'Start a project.',
  contact_text: 'Have something interesting in mind?',
  contact_email: 'hello@studio.test',
  contact_image: {
    url: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=500&q=85',
    alt: 'Portrait of the portfolio owner'
  }
};

export const projects = [
  {
    id: 1,
    title: 'North House',
    project_category: 'Brand Identity',
    project_description: 'A calm identity for modern living.',
    project_image: {
      url: 'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1200&q=85',
      alt: 'Modern North House interior'
    }
  },
  {
    id: 2,
    title: 'Still Journal',
    project_category: 'Editorial',
    project_description: 'A quieter way to read online.',
    project_image: {
      url: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?auto=format&fit=crop&w=1200&q=85',
      alt: 'Open editorial journal'
    }
  },
  {
    id: 3,
    title: 'Forma Objects',
    project_category: 'Digital Product',
    project_description: 'A tactile shop for everyday objects.',
    project_image: {
      url: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=1200&q=85',
      alt: 'Minimal objects in a refined interior'
    }
  }
];